module.exports = __webpack_public_path__ + "img/download.d00f4b07.svg";